// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A+SSN","title":"styles_title__ATU7X","content":"styles_content__6-YKF"};